



































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
    getCompanies,
    deleteCompany,
    deleteNotification,
    getNotifications,
    patchNotification,
} from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import get from 'lodash/get';
import Company from '../models/Company';
import HeaderDatatable from '../models/HeaderDatatable';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import { formatLegalForm } from '@/data/legalForms';
import NotificationModel from '../models/Notification';
import Datatable from '@/components/Datatable.vue';
import cloneDeep from 'lodash/cloneDeep';

@Component({
    components: {
        Datatable,
    },
})
export default class Notifications extends Vue {
    popupActive = false;
    record = false;
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 20,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: null,
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
            title: 'Nom',
            dataIndex: 'name',
            sorter: true,
            scopedSlots: {
                customRender: 'name',
            },
        },
        {
            title: 'Slug',
            dataIndex: 'slug',
            sorter: true,
        },
        {
            title: 'Description',
            dataIndex: 'description',
            sorter: true,
        },
        //        {
        //            title: 'Type',
        //            dataIndex: 'type',
        //            sorter: true,
        //        },
        {
            title: 'Titre de la notification',
            dataIndex: 'title',
            sorter: true,
        },
        //        {
        //            title: 'Contenu de la notification',
        //            dataIndex: 'content',
        //            sorter: true,
        //        },
        {
            title: 'Activé',
            dataIndex: 'enabled',
            scopedSlots: {
                customRender: 'enabled',
            },
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];
    async fetch(meta: MetaDatatable) {
        const { data } = await getNotifications({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }
    deleteText = {
        confirm: {
            title: `Suppression de la notification`,
            content: `Voulez-vous vraiment supprimer la notification ?`,
        },
        notify: {
            title: 'Notification supprimé',
            content: `La notification a bien été supprimé`,
        },
    };

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: NotificationModel | null;
    }) {
        const action = ev.action;
        const notification: NotificationModel | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (notification !== null) {
                    this.$router.push({
                        name: 'editNotification',
                        params: {
                            id: `${notification.id}`,
                        },
                    });
                }
                break;
            case 'delete':
                if (notification && notification.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                    await deleteNotification(notification.id);
                }
                break;
        }
    }

    deleteDialog(notification: NotificationModel) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(notification),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async toggleEnabled(notification: NotificationModel) {
        const $vs = (this as any).$vs;
        try {
            if (notification && notification.id) {
                const notificationEnabled = await patchNotification(
                    notification.id,
                    {
                        enabled: notification.enabled,
                    }
                );
                const enabled = notificationEnabled.data.enabled
                    ? 'activé'
                    : 'désactivé';
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: `Notification ${enabled}`,
                });
            }
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la modification de la notification`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    async acceptDeleteAlert(notification: NotificationModel) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({
                action: 'delete',
                item: notification,
            });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression de la notification`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    previewDialog(record: any) {
        this.record = record;
        this.popupActive = true;
    }
}
